"use client";

import createSvgIcon from "./utils/createSvgIcon.js";
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon([/*#__PURE__*/_jsx("path", {
  d: "M12 4C7.31 4 3.07 5.9 0 8.98L12 21l5-5.01V8h5.92C19.97 5.51 16.16 4 12 4m7 14h2v2h-2z"
}, "0"), /*#__PURE__*/_jsx("path", {
  d: "M19 10h2v6h-2z"
}, "1")], 'SignalWifiStatusbarConnectedNoInternet4Outlined');